import(/* webpackMode: "eager" */ "/opt/cal/apps/web/app/global-error.tsx");
